/**
 * ミニサウナストーブ出力計算ツール
 * コレクションページ用簡易版
 */

document.addEventListener('DOMContentLoaded', function() {
  const miniCalculator = document.getElementById('mini-stove-calculator');
  if (!miniCalculator) return;

  const form = miniCalculator.querySelector('.mini-calculator-form');
  const resultSection = miniCalculator.querySelector('.mini-calculator-result');
  const resultPower = miniCalculator.querySelector('.mini-result-power');

  if (!form) return;

  // フォーム送信イベント
  form.addEventListener('submit', function(e) {
    e.preventDefault();

    try {
      // 入力値取得
      const length = parseFloat(document.getElementById('mini-length').value) || 0;
      const width = parseFloat(document.getElementById('mini-width').value) || 0;
      const height = parseFloat(document.getElementById('mini-height').value) || 0;

      // バリデーション
      if (!validateInputs(length, width, height)) {
        return;
      }

      // 計算実行
      const requiredPower = calculatePower(length, width, height);

      // 結果表示
      displayResult(requiredPower);

      // GA4イベント送信
      if (typeof gtag !== 'undefined') {
        gtag('event', 'ミニストーブ計算実行', {
          event_category: 'ツール利用',
          有効体積: (length * width * height).toFixed(2),
          推奨出力: requiredPower.toFixed(1)
        });
      }

    } catch (error) {
      console.error('計算エラー:', error);
      alert('計算中にエラーが発生しました。入力内容をご確認ください。');
    }
  });

  // バリデーション
  function validateInputs(length, width, height) {
    const errors = [];

    if (length <= 0) errors.push('長さを入力してください');
    if (width <= 0) errors.push('幅を入力してください');
    if (height <= 0) errors.push('高さを入力してください');

    if (length > 50) errors.push('長さは50m以下で入力してください');
    if (width > 50) errors.push('幅は50m以下で入力してください');
    if (height > 10) errors.push('高さは10m以下で入力してください');

    if (errors.length > 0) {
      alert('入力エラー:\n' + errors.join('\n'));
      return false;
    }

    return true;
  }

  // 出力計算(簡易版 - ボックスタイプ室内設置想定)
  function calculatePower(length, width, height) {
    const volume = length * width * height;

    // 指数式で出力計算
    let requiredPower;
    if (volume <= 9) {
      requiredPower = 1.67 * Math.pow(volume, 0.66);
    } else {
      requiredPower = 2.81 * Math.pow(volume, 0.59);
    }

    // 0.1刻みで四捨五入
    return Math.round(requiredPower * 10) / 10;
  }

  // 結果表示
  function displayResult(power) {
    resultPower.textContent = power.toFixed(1);
    resultSection.style.display = 'block';
    resultSection.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
});